import { IsNotEmpty, IsUUID } from 'class-validator';

export class CompanyEventStatDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
